import { Route, Routes } from "react-router-dom";
import { lazy, Suspense } from "react";
import { Layout } from "components";

import { RouteConstants } from "../../constants";
import {
  ROUTE_PRIVACY_POLICY,
  ROUTE_TERMS_OF_USE,
  ROUTE_IMPRESSUM,
  ROUTE_DOWNLOAD,
} from "constants/route";

const HomePage = lazy(() => import("pages/home"));
const AboutUsPage = lazy(() => import("pages/about-us"));
const FaqPage = lazy(() => import("pages/faq-page"));
const CreditCardPage = lazy(() => import("pages/credit-card"));
const CreditCardRequestFormPage = lazy(() => import("pages/credit-card/form"));
const CreditRequestBasicPage = lazy(() => import("pages/credit-request/basic"));
const CreditRequestDocumentationPage = lazy(() => import("pages/credit-request/documentation"));
const CreditRequestExistsPage = lazy(() => import("pages/credit-request/exists"));
const CreditRequestFormPage = lazy(() => import("pages/credit-request/form/request"));
const CreditRequestLayout = lazy(() => import("pages/credit-request/layout"));
const CreditRequestOverviewPage = lazy(() => import("pages/credit-request/form/overview"));
const CreditRequestVerifyPage = lazy(() => import("pages/public/credit"));
const CardRequestVerifyPage = lazy(() => import("pages/public/card"));
const MobileAppPage = lazy(() => import("pages/mobile-app"));
const PrivacyPolicyPage = lazy(() => import("pages/privacy-and-policy"));
const TermsPage = lazy(() => import("pages/terms-of-use"));
const ImpressumPage = lazy(() => import("pages/impressum"));
const DownloadPage = lazy(() => import("pages/download"));
const Error404Page = lazy(() => import("pages/error/404"));
const Error406Page = lazy(() => import("pages/error/406"));
const Error500Page = lazy(() => import("pages/error/500"));
const Error503Page = lazy(() => import("pages/error/503"));

const {
  ROUTE_ABOUT_US,
  ROUTE_CREDIT_CARD,
  ROUTE_CREDIT_CARD_FORM,
  ROUTE_CREDIT_CARD_REQUEST_VERIFY,
  ROUTE_CREDIT_REQUEST,
  ROUTE_CREDIT_REQUEST_BASIC_SHORT,
  ROUTE_CREDIT_REQUEST_FORM_SHORT,
  ROUTE_CREDIT_REQUEST_EXISTS_SHORT,
  ROUTE_CREDIT_REQUEST_DOCUMENTATION_SHORT,
  ROUTE_CREDIT_REQUEST_OVERVIEW,
  ROUTE_CREDIT_REQUEST_VERIFY,
  ROUTE_ERROR_406,
  ROUTE_ERROR_500,
  ROUTE_ERROR_503,
  ROUTE_FAQ,
  ROUTE_HOME,
  ROUTE_MOBILE_APP,
} = RouteConstants;

const CustomRouter = () => {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route element={<Layout />}>
          <Route path={ROUTE_HOME} element={<HomePage />} />
          <Route path={ROUTE_ABOUT_US} element={<AboutUsPage />} />
          <Route path={ROUTE_FAQ} element={<FaqPage />} />
          <Route path={ROUTE_CREDIT_CARD} element={<CreditCardPage />} />
          <Route path={ROUTE_CREDIT_CARD_FORM} element={<CreditCardRequestFormPage />} />
          <Route path={ROUTE_MOBILE_APP} element={<MobileAppPage />} />
          <Route path={ROUTE_PRIVACY_POLICY} element={<PrivacyPolicyPage />} />
          <Route path={ROUTE_TERMS_OF_USE} element={<TermsPage />} />
          <Route path={ROUTE_IMPRESSUM} element={<ImpressumPage />} />
          <Route path={ROUTE_CREDIT_REQUEST} element={<CreditRequestLayout />}>
            <Route path={ROUTE_CREDIT_REQUEST_BASIC_SHORT} element={<CreditRequestBasicPage />}/>
            <Route path={ROUTE_CREDIT_REQUEST_FORM_SHORT} element={<CreditRequestFormPage />}/>
            <Route path={ROUTE_CREDIT_REQUEST_EXISTS_SHORT} element={<CreditRequestExistsPage />}/>
            <Route path={ROUTE_CREDIT_REQUEST_DOCUMENTATION_SHORT} element={<CreditRequestDocumentationPage />} />
            <Route path={ROUTE_CREDIT_REQUEST_OVERVIEW} element={<CreditRequestOverviewPage />}/>
            <Route path={ROUTE_CREDIT_REQUEST + "/:id"} element={<CreditRequestOverviewPage />}
            />
          </Route>
          <Route path={`${ROUTE_CREDIT_REQUEST_VERIFY}/:id`} element={<CreditRequestVerifyPage />} />
          <Route path={`${ROUTE_CREDIT_CARD_REQUEST_VERIFY}/:id`} element={<CardRequestVerifyPage />} />
        </Route>
        <Route path={ROUTE_DOWNLOAD} element={<DownloadPage />} />
        <Route path={ROUTE_ERROR_406} element={<Error406Page />} />
        <Route path={ROUTE_ERROR_500} element={<Error500Page />} />
        <Route path={ROUTE_ERROR_503} element={<Error503Page />} />
        <Route path="*" element={<Error404Page />} />
      </Routes>
    </Suspense>
  );
};

export default CustomRouter;
